/**
 * Global Swiper Class for Shopify Sections
 */
class GlobalSwiper {
    constructor(selector, customOptions = {}) {
      this.selector = selector;
      this.element = document.querySelector(selector);
  
      if (!this.element) {
        return;
      }
  
      this.defaults = {
        slidesPerView: 'auto',
        spaceBetween: 20,
        loop: false,
        breakpoints: {
          320: {
            slidesPerView: 1.2,
            spaceBetween: 15,
            centeredSlides: true
          },
          768: {
            slidesPerView: 'auto',
            spaceBetween: 20,
            centeredSlides: false
          }
        }
      };
  
      this.options = { ...this.defaults, ...customOptions };
      this.init();
    }
  
    init() {
      this.instance = new Swiper(this.element, this.options);
    }
  }
  
  // Expose the Class to the window object
  window.GlobalSwiper = GlobalSwiper;